var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5 3.24904V10.749C14.4996 10.8202 14.484 10.8905 14.4543 10.9552C14.4245 11.0198 14.3813 11.0774 14.3275 11.124C13.3725 11.9509 12.4594 12.249 11.5887 12.249C10.4069 12.249 9.30312 11.7028 8.27625 11.1959C6.61687 10.374 5.17438 9.66216 3.5 10.9847V13.749C3.5 13.8816 3.44732 14.0088 3.35355 14.1026C3.25979 14.1964 3.13261 14.249 3 14.249C2.86739 14.249 2.74021 14.1964 2.64645 14.1026C2.55268 14.0088 2.5 13.8816 2.5 13.749V3.24904C2.50048 3.17781 2.51617 3.1075 2.54603 3.04282C2.57589 2.97815 2.61922 2.9206 2.67313 2.87404C4.92313 0.925287 6.9425 1.92341 8.7225 2.80404C10.4375 3.65279 11.9244 4.38654 13.6725 2.87404C13.7448 2.8114 13.8335 2.7708 13.9281 2.75704C14.0227 2.74329 14.1193 2.75696 14.2064 2.79643C14.2935 2.8359 14.3674 2.89951 14.4195 2.97973C14.4715 3.05995 14.4995 3.15342 14.5 3.24904Z",
    fill: "#F98D23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.154ca3cef3c710e429db095dd43bbe22.svg";
export { ForwardRef as ReactComponent };